/* global $ */

import { Controller } from 'stimulus';
import Awesomplete from 'awesomplete';
import debounce from '../helpers/debounce';

const KEY_LEFT = 37;
const KEY_RIGHT = 39;
const KEY_DOWN = 40;
const KEY_UP = 38;
const KEY_SHIFT = 16;
const KEY_ESCAPE = 27;

const IGNORED_KEYS = [KEY_UP, KEY_DOWN, KEY_RIGHT, KEY_LEFT, KEY_SHIFT, KEY_ESCAPE];

class SearchBar extends Controller {
  connect() {
    // Create the Awesomplete instance
    this.awesomplete = new Awesomplete(this.inputTarget, {
      maxItems: 10,
      minChars: 3,
      list: [],
      filter: SearchBar.filter,
      item: SearchBar.item,
      replace: this.replace.bind(this),
      sort: () => 0,
    });

    this.debouncedSearch = debounce(this.search.bind(this), 250);
  }

  onKeyup(e) {
    if (IGNORED_KEYS.indexOf(e.keyCode) >= 0) {
      return;
    }

    const searchQuery = e.target.value;
    this.debouncedSearch(searchQuery);
  }

  search(searchQuery) {
    $.ajax({
      url: `/api/autocomplete?search=${searchQuery}`,
      dataType: 'json',
      success: (data) => {
        this.awesomplete.list = data;
        this.awesomplete.evaluate();
      },
    });
  }

  static filter() {
    return true;
  }

  /**
   * Render a single item in the Awesomplete dropdown
   * @param {Object} obj Object of the current item returned from the API
   * @return {Node} DOM node to render
   */
  static item(obj) {
    return $('<li>', {
      html: `
        <strong class="d-block">${obj.label.label}</strong>
      `,
      'aria-selected': 'false',
      class: 'awesomplete__item',
    })[0];
  }

  /**
   * Handles the replacing of text in the input field when a item is selected
   * @param {Object} obj Object of the current item returned from the API
   * @return {Void}
   */
  replace(obj) {
    if (typeof obj.value.redirect_url !== 'undefined') {
      window.location = obj.value.redirect_url;
      return;
    }

    this.inputTarget.value = obj.value.label;

    const $form = $(this.inputTarget).parents('form');

    if ($form.length) {
      $form.submit();
    }
  }
}

SearchBar.targets = [
  'input',
  'submit',
];

export default SearchBar;
